// Common settings used by all types
export const COMMON_SETTINGS = {
  conditions: {
    label: 'Conditions',
    type: 'string',
    required: false,
  },
  name: {
    label: 'Name',
    type: 'string',
    required: false,
  },
};

// Specific schema for DIALOG type
export const DIALOG_SETTINGS = {
  // FOR ALL
  type: {
    label: 'Type',
    type: 'select',
    options: ['text', 'item', 'input', 'option', 'range', 'boolean', 'button'],
    required: true,
  },

  // ITEM COMPONENT
  material: {
    label: 'Material',
    type: 'material',
    hiddenIfIAm: ['text', 'input', 'option', 'range', 'boolean', 'button'],
    required: true,
  },
  height: {
    label: 'Height',
    type: 'string',
    hiddenIfIAm: ['text', 'input', 'option', 'range', 'boolean', 'button'],
    required: false,
  },
  text: {
    label: 'Text',
    type: 'string',
    hiddenIfIAm: ['text', 'input', 'option', 'range', 'boolean', 'button'],
    required: false,
  },

  // INPUT COMPONENT SOME SHARED
  width: {
    label: 'Width',
    type: 'string',
    hiddenIfIAm: ['boolean'],
    required: false,
  },
  initial: {
    label: 'Initial Value',
    type: 'string',
    hiddenIfIAm: ['text', 'item'],
    required: false,
  },
  'max-length': {
    label: 'Max Length',
    type: 'string',
    hiddenIfIAm: ['text', 'item', 'option', 'range', 'boolean', 'button'],
    required: false,
  },
  'multiline-rows': {
    label: 'Multiline Rows',
    type: 'group',
    hiddenIfIAm: ['text', 'item', 'option', 'range', 'boolean', 'button'],
    required: false,
  },
  'multiline-height': {
    label: 'Multiline Height',
    type: 'group',
    hiddenIfIAm: ['text', 'item', 'option', 'range', 'boolean', 'button'],
    required: false,
  },

  // OPTION COMPONENT
  options: {
    label: 'Options',
    type: 'list',
    hiddenIfIAm: ['text', 'item', 'input', 'range', 'boolean', 'button'],
    required: true,
  },

  // RANGE COMPONENT
  step: {
    label: 'Step',
    type: 'string',
    hiddenIfIAm: ['text', 'item', 'input', 'option', 'boolean', 'button'],
    required: false,
  },
  start: {
    label: 'Start',
    type: 'string',
    hiddenIfIAm: ['text', 'item', 'input', 'option', 'boolean', 'button'],
    required: false,
  },
  end: {
    label: 'End',
    type: 'string',
    hiddenIfIAm: ['text', 'item', 'input', 'option', 'boolean', 'button'],
    required: false,
  },

  // BUTTON COMPONENT
  url: {
    label: 'URL',
    type: 'string',
    hiddenIfIAm: ['text', 'item', 'input', 'option', 'range', 'boolean'],
    required: false,
  },
  clipboard: {
    label: 'Clipboard Text',
    type: 'string',
    hiddenIfIAm: ['text', 'item', 'input', 'option', 'range', 'boolean'],
    required: false,
  },
  tooltip: {
    label: 'Tooltip',
    type: 'string',
    hiddenIfIAm: ['text', 'item', 'input', 'option', 'range', 'boolean'],
    required: false,
  },
};

// Inventory type conflicts (anything that matches in Dialog since inventory keys are imported into dialog for the item type)
export const INVENTORY_CONFLICTS = {
  tooltip: {
    label: 'Show Tooltip',
    type: 'boolean',
    required: false,
  },
};
// Specific schema for inventory type
export const INVENTORY_SETTINGS = {
  material: {
    label: 'Material',
    type: 'material',
    required: true,
    hiddenIfIAm: ['text', 'input', 'option', 'range', 'boolean', 'button'],
  },

  lore: {
    label: 'Lore',
    type: 'list',
    required: false,
    hiddenIfIAm: ['text', 'input', 'option', 'range', 'boolean', 'button'],
  },

  stack: {
    label: 'Stack',
    type: 'string',
    required: false,
    hiddenIfIAm: ['text', 'input', 'option', 'range', 'boolean', 'button'],
  },

  attributes: {
    label: 'Show Attributes',
    type: 'boolean',
    required: false,
    hiddenIfIAm: ['text', 'input', 'option', 'range', 'boolean', 'button'],
  },

  'tooltip-style': {
    label: 'Tooltip Style',
    type: 'string',
    required: false,
    hiddenIfIAm: ['text', 'input', 'option', 'range', 'boolean', 'button'],
  },

  'item-model': {
    label: 'Item Model',
    type: 'string',
    required: false,
    hiddenIfIAm: ['text', 'input', 'option', 'range', 'boolean', 'button'],
  },

  'custom-model-data': {
    label: 'Custom Model Data',
    type: 'string',
    required: false,
    hiddenIfIAm: ['text', 'input', 'option', 'range', 'boolean', 'button'],
  },

  animate: {
    label: 'Animation',
    type: 'string',
    required: false,
    hiddenIfIAm: ['text', 'input', 'option', 'range', 'boolean', 'button'],
  },

  enchantments: {
    label: 'Enchantments',
    type: 'list',
    required: false,
    hiddenIfIAm: ['text', 'input', 'option', 'range', 'boolean', 'button'],
  },

  'glint-override': {
    label: 'Glint Override',
    type: 'boolean',
    required: false,
    hiddenIfIAm: ['text', 'input', 'option', 'range', 'boolean', 'button'],
  },

  damage: {
    label: 'Damage',
    type: 'string',
    required: false,
    hiddenIfIAm: ['text', 'input', 'option', 'range', 'boolean', 'button'],
  },

  'leather-color': {
    label: 'Leather Color',
    type: 'string',
    required: false,
    hiddenIfIAm: ['text', 'input', 'option', 'range', 'boolean', 'button'],
  },

  'armor-trim': {
    label: 'Armor Trim',
    type: 'string',
    required: false,
    hiddenIfIAm: ['text', 'input', 'option', 'range', 'boolean', 'button'],
  },

  potion: {
    label: 'Potion Effect',
    type: 'string',
    required: false,
    hiddenIfIAm: ['text', 'input', 'option', 'range', 'boolean', 'button'],
  },

  'potion-color': {
    label: 'Potion Color',
    type: 'string',
    required: false,
    hiddenIfIAm: ['text', 'input', 'option', 'range', 'boolean', 'button'],
  },

  banner: {
    label: 'Banner Patterns',
    type: 'list',
    required: false,
    hiddenIfIAm: ['text', 'input', 'option', 'range', 'boolean', 'button'],
  },
};

// Specific schema for floodgate type
export const FLOODGATE_SETTINGS = {
  // FOR ALL
  type: {
    label: 'Type',
    type: 'select',
    options: ['button', 'label', 'dropdown', 'input', 'slider', 'step-slider', 'toggle'],
    required: true,
  },
  // FOR BUTTON ONLY
  'icon-type': {
    label: 'Icon Type',
    type: 'select',
    options: ['PATH', 'URL'],
    hiddenIfIAm: ['label', 'dropdown', 'input', 'slider', 'step-slider', 'toggle'],
    required: false,
  },
  'icon-texture': {
    label: 'Icon Texture',
    type: 'string',
    hiddenIfIAm: ['label', 'dropdown', 'input', 'slider', 'step-slider', 'toggle'],
    required: false,
  },
  // FOR DROPDOWN ONLY
  options: {
    label: 'Options',
    type: 'list',
    hiddenIfIAm: ['button', 'label', 'input', 'slider', 'step-slider', 'toggle'],
    required: true,
  },
  // FOR INPUT
  default: {
    label: 'Default Value',
    type: 'string',
    hiddenIfIAm: ['button', 'label'],
    required: false,
  },
  placeholder: {
    label: 'Placeholder',
    type: 'string',
    hiddenIfIAm: ['button', 'label', 'dropdown', 'slider', 'step-slider', 'toggle'],
    required: false,
  },
  // SLIDER ONLY
  min: {
    label: 'Minimum',
    type: 'string',
    hiddenIfIAm: ['button', 'label', 'dropdown', 'input', 'step-slider', 'toggle'],
    required: false,
  },
  max: {
    label: 'Maximum',
    type: 'string',
    hiddenIfIAm: ['button', 'label', 'dropdown', 'input', 'step-slider', 'toggle'],
    required: false,
  },
  step: {
    label: 'Step',
    type: 'string',
    hiddenIfIAm: ['button', 'label', 'dropdown', 'input', 'step-slider', 'toggle'],
    required: false,
  },
  // STEP SLIDER ONLY
  steps: {
    label: 'Steps',
    type: 'list',
    hiddenIfIAm: ['button', 'label', 'dropdown', 'input', 'slider', 'toggle'],
    required: true,
  },
};

// Compose schemas by merging common with specific
export const ITEM_SETTINGS_SCHEMA = {
  dialog: {
    ...COMMON_SETTINGS,
    ...DIALOG_SETTINGS,
    ...INVENTORY_SETTINGS,
  },
  inventory: {
    ...COMMON_SETTINGS,
    ...INVENTORY_SETTINGS,
    ...INVENTORY_CONFLICTS,
  },
  floodgate: {
    ...COMMON_SETTINGS,
    ...FLOODGATE_SETTINGS,
  },
};